import {gql} from 'graphql-request';
import {saasFragment} from "../shared/Fragments";

// Gets a list of companies that the logged in user has access to
export const getAllClientsQuery = gql`
query ListClients {
    client(order_by:{name:asc}){
          pub_id
          name
          slug
          is_disabled
      }
}`;

export const getAllClientsWithFeaturesQuery = gql`
query ListClients {
    client(order_by:{name:asc}){
          pub_id
          name
          slug
          is_disabled
          source_of_truth_saas{
            ...Saas
          }
      }
}${saasFragment}`;

export const createClientMutation = gql`
mutation CreateClient($client_id: uuid, $client: CreateClientRequest!){
  insert_client_record(client_id: $client_id, client:$client) {
    id
  }
}`;

export const updateClientMutation = gql`
mutation UpdateClient($client_id: uuid, $client: UpdateClientRequest!){
  update_client_record(client_id: $client_id, client:$client) {
    id
  }
}`;

export const deleteClientMutation = gql`
mutation DeleteClient($client_id: uuid!, $req: DeleteClientRequest!){
  delete_client_record(client_id: $client_id, req:$req) {
    id
  }
}`;

// The notification settings live in the client's configuration
export const clientNotificationSettingsQuery = gql`
query ClientNotificationSettings($clientBoolExp: client_bool_exp) {
    client(where: $clientBoolExp){
          pub_id
          name
          configuration
      }
}`;

export const updateClientNotificationSettingsMutation = gql`
mutation UpdateClientNotificationSettings($client_id: uuid, $req: UpdateClientNotificationSettingsRequest!){
  update_client_notification_settings(client_id: $client_id, req: $req) {
    id
  }
}`;
